// Saves a Blob to the user's device under `fileName` by clicking a temporary object-URL link — the browser's standard
// download path for content fetched with script (e.g. a CSV streamed back from a POST).
export function downloadBlob(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

// The file name from a Content-Disposition header, preferring the RFC 5987 `filename*` form; null when absent.
export function fileNameFromContentDisposition(header: string | null | undefined): string | null {
  if (!header)
    return null;
  const extended = /filename\*\s*=\s*(?:UTF-8'')?([^;]+)/i.exec(header);
  if (extended)
    return decodeURIComponent(extended[1].trim().replace(/^"|"$/g, ''));
  const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(header);
  return plain ? plain[1].trim() : null;
}
